import React from "react";
import styled from "@emotion/styled";
import MenuButton from "@pages/myPage/_component/MenuButton";

interface IMenuChildren {
  title: string;
  route?: string;
  render?: () => React.ReactNode;
  externalLink?: string;
  state?: any;
}

interface IMenuType {
  title: string;
  children: IMenuChildren[];
}

const InfoPanel = () => {
  const menu = [
    {
      title: "내 거래 관리",
      children: [
        {
          title: "판매 정책 설정",
          route: "/sales-policy",
        },

        {
          title: "계좌관리",
          route: "/bank-account-management",
        },
      ],
    },
    {
      title: "고객서비스",
      children: [
        {
          title: "1:1 문의 / 제안 / 제보",
          route: "/one-inquiry",
        },
        {
          title: "FAQ",
          route: "/faq",
        },
        {
          title: "샤카라카 앱서비스 이용가이드",
          externalLink:
            "https://owlsociety.notion.site/Guide-1335602230714890936174f5b62a91cd",
        },
        {
          title: "이용약관",
          externalLink:
            "https://owlsociety.notion.site/Terms-of-Use-f730e5a7ab0f4494b5bfc6b7322e8e56",
        },
        {
          title: "개인정보 처리방침",
          externalLink:
            "https://owlsociety.notion.site/c44be8e60e8f4589a5b8dc50ce22f6ad",
        },
      ],
    },
    {
      title: "회원 정보 관리",
      children: [
        {
          title: "계정관리",
          route: "/account-management",
        },
      ],
    },
  ];

  return (
    <Container>
      {menu.map((menu: IMenuType, index: number) => (
        <MenuContainer key={index}>
          <MenuTitle>{menu.title}</MenuTitle>

          <MenuButtonList>
            {menu.children.map((children: IMenuChildren, index: number) => (
              <MenuButton
                key={index}
                title={children.title}
                route={children.route}
                render={children.render}
                externalLink={children.externalLink}
                state={children.state}
              />
            ))}
          </MenuButtonList>
        </MenuContainer>
      ))}
    </Container>
  );
};

export default InfoPanel;

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  // backgroundColor: theme.color.border_gray,
}));

const MenuContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#fff",
  padding: "2rem",
  gap: "3.2rem",
});

const MenuTitle = styled.h3(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.semiBold,
  color: theme.color.green,
}));

const MenuButtonList = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3.2rem",
});
